<script>
  import notify from "../../../../../../Script/notify"
  import { createEventDispatcher } from "svelte"
  import ApplicationState from "../../../../../../Stores/applicationStates"
  const dispatch = createEventDispatcher()
  let userDetails = {
    name: "sdrs",
    organization: "IIM Ahmedabad",
    issuedDate: "",
    expireDate: "",
    credentialID: 123,
    credentialURL: "https://bcdc.iima.ac.in/docs/6f1bec98667825ec1c8a71592e635ed99ae2ff831735e75a80f3a17d1bb18e16",
  }

  export let organizationId = ""

  /**
   * @type {Boolean} whether to apply styles for invalid issued date input box
   */
  let invalidIssuedDate = true
  /**
   * @type {Boolean} whether to apply styles for invalid expired date input box
   */
  let invalidExpiredDate = false
  /**
   * @typedef {Object} notificationIssued
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationIssued}
   */
  let notificationIssued = {
    close() {},
  }
  /**
   * @typedef {Object} notificationExpired
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationExpired}
   */
  let notificationExpired = {
    close() {},
  }
  /**
   * @typedef {Object} notificationName
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationName}
   */
  let notificationName = {
    close() {},
  }
  /**
   * @typedef {Object} notificationOrganisation
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationOrganisation}
   */
  let notificationOrganisation = {
    close() {},
  }

  /**
   * Function for validating the issued Date
   * @param e binded the targetted event
   */
  const validateIssuedDate = (e) => {
    let givenDate = new Date(e.target.value)
    let currentDate = new Date()

    // Remove the time component from both dates
    givenDate.setHours(0, 0, 0, 0)
    currentDate.setHours(0, 0, 0, 0)

    if (givenDate > currentDate) {
      notificationIssued.close()
      notificationIssued = notify.danger("Invalid Issued Date")
      userDetails.issuedDate = ""
      return false // Given date is greater than today
    } else {
      return true // Given date is valid
    }
  }

  const isDateExpired = (e) => {
    let expirationDate = new Date(e.target.value)
    let currentDate = new Date()

    // Remove the time component from both dates
    expirationDate.setHours(0, 0, 0, 0)
    currentDate.setHours(0, 0, 0, 0)

    // Compare the dates
    if (expirationDate < currentDate) {
      notificationExpired.close()
      notificationExpired = notify.danger("Invalid Expired Date")
      userDetails.expireDate = ""
      return true // Expiration date is in the past
    } else {
      return false // Expiration date is valid
    }
  }

  const trimSpacesUsername = () => {
    userDetails.name = userDetails.name.trim()
    if (!userDetails.name) {
      notificationName.close()
      notificationName = notify.danger("Name shouldn't be empty")
    }
  }

  const trimSpacesOrganisation = () => {
    userDetails.organization = userDetails.organization.trim()
    if (!userDetails.organization) {
      notificationOrganisation.close()
      notificationOrganisation = notify.danger("Name shouldn't be empty")
    }
  }
</script>

<div class="fixed inset-0 z-10 flex items-center justify-center overflow-hidden bg-[#000000cc] backdrop-blur-md">
  <form on:submit|preventDefault>
    <div class="relative m-6 w-[400px] transform select-none rounded-md bg-white text-left transition-all dark:bg-bodyblack mobile:w-[500px] md:m-0 md:w-[700px]">
      <div class="flex w-full flex-col items-center justify-center rounded-md bg-white px-6 pt-6 text-black dark:bg-bodyblack gap-5">
        <h1 class="text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Add LinkedIn Button</h1>
        <div class="w-3/4 break-words text-center text-gray-400 dark:text-gray-200">Kindly provide the organization or company ID associated with your LinkedIn profile. Please ensure the ID provided is accurate.</div>
      </div>

      <div class="flex w-full flex-col items-center gap-6 px-8 py-5 text-gray-400">
        <!-- <div class="w-full items-center sm:grid sm:grid-cols-4">
          <div class="label-text">Name</div>
          <div class="col-span-2 sm:mt-0">
            <input on:blur={trimSpacesUsername} required type="text" bind:value={userDetails.name} class="normal-btn invalid-class text-gray-800 dark:text-slate-200" placeholder="Enter Name" />
          </div>
        </div> -->
        <div class="w-full items-center sm:grid sm:grid-cols-4">
          <div class="label-text">Organization / Company ID</div>
          <div class="col-span-2 sm:mt-0">
            <input
              on:blur={() => {
                organizationId = organizationId.trim()
              }}
              required
              type="text"
              bind:value={organizationId}
              class="normal-btn invalid-class text-gray-800 dark:text-slate-200"
              placeholder="Organization / Company ID"
            />
          </div>
        </div>
        <!-- <div class="w-full items-center sm:grid sm:grid-cols-4">
          <div class="label-text">Issue Date</div>
          <div class="col-span-2 sm:mt-0">
            <input
              on:change={(e) => {
                notificationIssued.close()
                invalidIssuedDate = validateIssuedDate(e)
              }}
              on:focus={(e) => {
                e.target.type = "date"
              }}
              placeholder="Issued Date"
              type="text"
              style="color-scheme: {$ApplicationState.darkMode ? 'dark' : 'light'}"
              bind:value={userDetails.issuedDate}
              class="block w-full appearance-none rounded-md border bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-200 outline-none placeholder:text-gray-400 focus:ring-1 dark:text-slate-200 {!invalidIssuedDate ? 'border-red-500 placeholder-red-500 focus:border-red-500 focus:ring-red-500' : 'border-[#a0a1a580] focus:border-blue-500 focus:ring-blue-500'}"
            />
          </div>
        </div>
        <div class="w-full items-center sm:grid sm:grid-cols-4">
          <div class="label-text">Expiration Date</div>
          <div class="col-span-2 sm:mt-0">
            <input
              on:change={(e) => {
                notificationExpired.close()
                invalidExpiredDate = isDateExpired(e)
              }}
              on:focus={(e) => {
                e.target.type = "date"
              }}
              type="text"
              style="color-scheme: {$ApplicationState.darkMode ? 'dark' : 'light'}"
              placeholder="Expired Date"
              bind:value={userDetails.expireDate}
              class="block w-full appearance-none rounded-md border bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-200 outline-none placeholder:text-gray-400 focus:ring-1 dark:text-slate-200 {invalidExpiredDate ? 'border-red-500 placeholder-red-500 focus:border-red-500 focus:ring-red-500' : 'border-[#a0a1a580] focus:border-blue-500 focus:ring-blue-500'}"
            />
          </div>
        </div>
        <div class="w-full items-center sm:grid sm:grid-cols-4">
          <div class="label-text">Credential ID</div>
          <div class="col-span-2 sm:mt-0">
            <input type="number" bind:value={userDetails.credentialID} class="normal-btn text-gray-800 dark:text-slate-200" placeholder="Enter Credential ID" />
          </div>
        </div>
        <div class="w-full items-center sm:grid sm:grid-cols-4">
          <div class="label-text">Credential URL</div>
          <div class="col-span-2 sm:mt-0">
            <input type="text" bind:value={userDetails.credentialURL} class="normal-btn text-gray-800 dark:text-slate-200" placeholder="Enter Credential URL" />
          </div>
        </div> -->
      </div>

      <div class="flex flex-row items-center justify-center gap-3 rounded-md bg-white p-6 dark:bg-bodyblack sm:flex md:gap-0">
        <button on:click type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-red-500 hover:text-white focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-red-500 sm:ml-3 sm:w-auto">
          <span>
            <i class="fa-solid fa-circle-xmark" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Close</span>
        </button>

        <button
          on:click={() => {
            dispatch("insert", organizationId)
          }}
          type="button"
          disabled={!organizationId}
          class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-green-500 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-[#f7f7f7]/50 disabled:text-gray-900/50 dark:bg-lightgray dark:text-white dark:hover:bg-green-500 sm:ml-3 sm:w-auto"
        >
          <span>
            <i class="fa-solid fa-link" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Insert Button</span>
        </button>
      </div>
    </div>
  </form>
</div>

<style lang="postcss">
  .normal-btn {
    @apply block w-full appearance-none rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm  placeholder-gray-200 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500;
  }
  .invalid-class {
    @apply invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:invalid:border-red-500 focus:invalid:ring-red-500;
  }
  .label-text {
    @apply col-span-2 mb-1 block select-none text-base font-medium text-gray-500  sm:mb-0;
  }
  input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
</style>
